import { render, staticRenderFns } from "./yearWiseResult.vue?vue&type=template&id=108e982a&scoped=true&"
import script from "./yearWiseResult.vue?vue&type=script&lang=js&"
export * from "./yearWiseResult.vue?vue&type=script&lang=js&"
import style0 from "./yearWiseResult.vue?vue&type=style&index=0&id=108e982a&lang=scss&scoped=true&"
import style1 from "./yearWiseResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e982a",
  null
  
)

export default component.exports